import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { listProducts } from "../actions/productActions";
import { Button, Col, Modal, Row, Image } from "react-bootstrap";
import Case2 from "./FormLensComponent/Case2";
import Case3 from "./FormLensComponent/Case3";
// import Case1 from "./FormLensComponent/Case1";
import Case4 from "./FormLensComponent/Case4";
import Case5 from "./FormLensComponent/Case5";

function FormLens({
  type,
  setType,
  product,
  addToCartHandler,
  setSpecification,
  Specification,
}) {
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.productList);
  const { products } = productList;
  const [show, setShow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeKey, setActiveKey] = useState("");
  const [Id, SetId] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(true);
  const [isOnlyFrame, setIsOnlyFrame] = useState(false);
  const [selectedLens, setSelectedLens] = useState({});

  // fetching the frame lens that will be selected later on
  let framebox = [];
  framebox = frameproducts(product.frameIds);
  function frameproducts(frameIds) {
    // console.log(frameIds);
    if (!frameIds) {
      return [];
    }
    const data = products.filter((product) => frameIds.includes(product._id));
    // console.log("here is the data", data);
    return data;
  }

  // console.log("here is the similar products", similarbox);

  useEffect(() => {
    dispatch(listProducts());
    const handleResize = () => {
      if (window.innerWidth < 768) {
        // Adjust the breakpoint as per your needs
        setIsFullscreen(false);
      } else {
        setIsFullscreen(true);
      }
    };

    handleResize(); // Initial check

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch]);
  const initialFormValues = {
    od_sph: 0,
    od_cyl: 0,
    od_axis: 0,
    os_sph: 0,
    os_cyl: 0,
    os_axis: 0,
    Add_Power: 0,
    pd_type: " ",
    pd_value: 0,
    PrescriptionImage: " ",
  };
  const [formData, setFormData] = useState(initialFormValues);
  const handleChange = (fieldName, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
  };
  const lensDataArray = [
    {
      id: "1",
      lensname: "Clear 1",
      price: 39.99,
      logo: "lens_logo_1.png",
      lensDesc:
        "Scratch-resistant, anti-reflective lenses that block 100% of UV rays",
      lensTable: [
        { column1: "Feature 1", column2: "Value 2" },
        { column1: "Feature 2", column2: "Value 5" },
        { column1: "Feature 3", column2: "Value 5" },
        { column1: "Feature 4", column2: true },
        { column1: "Feature 5", column2: true },
        { column1: "Feature 6", column2: true },
        { column1: "Feature 7", column2: true },
        { column1: "Both Side Anti Reflective Coating", column2: false },
        { column1: "Feature 9", column2: "Value 5" },
        // Add more rows as needed
      ],
    },
  ];

  const handleBuyFrame = () => {
    setShow(true);
    setIsOnlyFrame(true);
    setSpecification({ ...Specification, onlyFrame: true });
    setType("5");
  };
  const handleShow = () => {
    setShow(true);
  };
  // const Handleform1 = (value) => {
  //   setSpecification({ ...Specification, frame: value });
  //   setType("2");
  // };
  const Handleform2 = (value) => {
    setSpecification({ ...Specification, prescriptionType: value });
    setType("3");
  };
  const Handleform3 = (value) => {
    const parts = value.split("?");
    setSpecification({
      ...Specification,
      lens: parts[0],
      lensprice: Number(parts[1]),
    });
    const Lens = framebox.find((lens) => lens._id === parts[0]);

    setSelectedLens(Lens);
    setType("4");
  };
  const uploadPrescriptionHandler = async (e) => {
    const file = e.target.files[0];
    const formData1 = new FormData();
    formData1.append("PrescriptionImage", file);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        "/api/upload/PrescriptionImage",
        formData1,
        config
      );
      // /uploads\PrescriptionImage-1715725887109.png data that we are getting
      // const ImageId = data.match(/\d+/)[0];
      const ImageId = data.substring(data.lastIndexOf("-") + 1);
      // console.log(ImageId);
      // console.log(data);
      setFormData({
        ...formData,
        PrescriptionImage: ImageId,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const Handleform4 = (event) => {
    const form = event.currentTarget;
    const fileInput = document.getElementById("uploadedPrescription");

    if (form.checkValidity() === false) {
      event.preventDefault();
    } else if (activeKey === "upload" && !fileInput.files.length) {
      // Check if the active section is upload and if no file is selected
      alert("please select a file when choosen file upload");
      event.preventDefault();
    } else {
      setSpecification(() => ({
        ...Specification,
        ManualValues: formData,
      }));
      setType("5");
    }
  };
  const handleClose = () => {
    setIsOnlyFrame(false);
    setType("2");
    setSpecification({
      ...Specification,
      // frame: "",
      prescriptionType: " ",
      qty: 1,
      onlyFrame: false,
      lens: " ",
      ManualValues: {
        od_sph: 0,
        od_cyl: 0,
        od_axis: 0,
        os_sph: 0,
        os_cyl: 0,
        os_axis: 0,
        Add_Power: 0,
        pd_type: " ",
        pd_value: 0,
        PrescriptionImage: " ",
      },
    });
    setShow(false);
  };
  // const handleBack1 = () => {
  //   setType("1");
  // };
  const handleBack2 = () => {
    setType("2");
  };
  const handleBack3 = () => {
    setFormData({
      ...formData,
      PrescriptionImage: " ",
      od_sph: 0,
      od_cyl: 0,
      od_axis: 0,
      os_sph: 0,
      os_cyl: 0,
      os_axis: 0,
      Add_Power: 0,
      pd_type: " ",
      pd_value: 0,
    });
    setType("3");
  };
  const handleBack4 = () => {
    setFormData({
      ...formData,
      PrescriptionImage: " ",
      od_sph: 0,
      od_cyl: 0,
      od_axis: 0,
      os_sph: 0,
      os_cyl: 0,
      os_axis: 0,
      Add_Power: 0,
      pd_type: " ",
      pd_value: 0,
    });
    setType("4");
  };
  return (
    <>
      <Button
        type='button'
        onClick={handleShow}
        disabled={product.countInStock === 0}
        className=' Psbutton shadow btn-light m-2'
      >
        Select Lenses/Buy
      </Button>
      <Button
        onClick={handleBuyFrame}
        type='button'
        disabled={product.countInStock === 0}
        style={{ border: "1px solid #2f99d1", borderRadius: "2.5rem" }}
        className='shadow btn-light'
      >
        Buy Frame @ {product.price}
      </Button>

      <Modal
        //  when the modal body ka cheeze badh jaye toh scrollable karke ek feature daal sakte hai
        animation
        backdrop='static'
        // size='xl'
        dialogClassName={isFullscreen ? "" : "modal-xl"}
        fullscreen={isFullscreen}
        show={show}
        onHide={handleClose}
      >
        <Row style={{ height: "100%" }}>
          <Col style={{ margin: "auto" }} className='text-center' md={4}>
            <Image src={product.image} alt={product.name} fluid />
            <h3>{product.name}</h3>
          </Col>

          {(() => {
            switch (type) {
              // case "1":
              //   return (
              //     <Case1 handleClose={handleClose} Handleform1={Handleform1}/>
              //   );
              case "2":
                return (
                  <Case2 handleClose={handleClose} Handleform2={Handleform2} />
                );
              case "3":
                return (
                  <Case3
                    isExpanded={isExpanded}
                    lensDataArray={lensDataArray}
                    framebox={framebox}
                    handleBack2={handleBack2}
                    setIsExpanded={setIsExpanded}
                    SetId={SetId}
                    Handleform3={Handleform3}
                    product={product}
                  />
                );
              case "4":
                return (
                  <Case4
                    activeKey={activeKey}
                    setActiveKey={setActiveKey}
                    handleBack3={handleBack3}
                    Handleform4={Handleform4}
                    handleChange={handleChange}
                    Specification={Specification}
                    uploadPrescriptionHandler={uploadPrescriptionHandler}
                  />
                );
              case "5":
                return (
                  <Case5
                    isOnlyFrame={isOnlyFrame}
                    handleBack4={handleBack4}
                    Specification={Specification}
                    product={product}
                    setSpecification={setSpecification}
                    selectedLens={selectedLens}
                    addToCartHandler={addToCartHandler}
                  />
                );

              default:
                return (
                  <Col>
                    Sorry some Error is there, The technical team is looking
                    into it.
                  </Col>
                );
            }
          })()}
        </Row>
      </Modal>
    </>
  );
}

export default FormLens;
